import React, { useEffect, useState } from 'react'
import { Col, Form, Modal, Row } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import { cloneChildComponents } from '../../../utils/helpers'

// Handles the view of M365 DISABLE_USER
function EnableMfa(props) {
  const { children, ...rest } = props // eslint-disable-line react/prop-types
  const { actionData, setActionData, selectedCustomer, selectedEmployees, setCompletedActions } = rest

  const ENABLE_MFA_ACTION_ID = 'ENGAGE.MFA_ENABLED_SUCCESSFULLY'

  const NO_MFA_TYPE = 'none'

  // Local state
  const [selectedEmployeesWithMfaDisabled, setSelectedEmployeesWithMfaDisabled] = useState([])
  const [nonBrowserSignIn, setNonBrowserSignIn] = useState(false)

  // Handles setting the completed action
  useEffect(() => {
    setCompletedActions((alreadyCompletedActions) => [...alreadyCompletedActions, ENABLE_MFA_ACTION_ID])
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  // Handles filtering employees to get the correct employees to enable mfa for
  useEffect(() => {
    if (selectedEmployees?.length) {
      const selectedEmployeesWithMfaDisabledArray = selectedEmployees.filter(
        (employee) => employee?.mfaConfigurations?.configurationStatus !== 'PER_USER_MFA',
      )
      setSelectedEmployeesWithMfaDisabled(selectedEmployeesWithMfaDisabledArray)
    }
  }, [selectedEmployees])

  // Handles setting the task parameters in the actionData which will be used by the footer when firing off the task
  useEffect(() => {
    setActionData({
      ...actionData,
      employeeGuids: selectedEmployeesWithMfaDisabled.map((employee) => employee.employeeIdentifier),
      nonBrowserSignIn: !!nonBrowserSignIn,
      selectedCustomer,
      mfaType: NO_MFA_TYPE, // Expected value from probe is "none" when null
    })
  }, [selectedEmployeesWithMfaDisabled, nonBrowserSignIn, selectedCustomer]) // eslint-disable-line react-hooks/exhaustive-deps

  // Formats the disabled checkbox displayed within the modal
  const disabledEnableMfaCheckboxLabel = (checkboxType) => (
    <div className="font-color-3">
      <FormattedMessage id={checkboxType} />
      &nbsp;
      {checkboxType === 'ENGAGE.ENABLE_MFA_CHECKBOX' && (
        <p style={{ color: 'var(--bs-secondary-color)' }}>
          <FormattedMessage id={`${checkboxType}_2`} />
        </p>
      )}
    </div>
  )

  // Handles the user selecting the non-browser sign in checkbox
  const handleNonBrowserSignIn = () => {
    if (nonBrowserSignIn) {
      setNonBrowserSignIn(false)
    } else {
      setNonBrowserSignIn(true)
    }
  }

  // Render
  return (
    <Form>
      <Modal.Body>
        <Row>
          <Col sm="12" md="12" lg="12">
            <div id="enableMfaContainer">
              <p className="font-bolder font-color-3" style={{}}>
                <FormattedMessage id="ENGAGE.ENABLE_MFA" />
              </p>
              <Form.Check
                custom
                type="checkbox"
                id="enableMfaCheck"
                checked
                disabled
                style={{ marginLeft: '20px' }}
                label={disabledEnableMfaCheckboxLabel('ENGAGE.ENABLE_MFA_CHECKBOX')}
              />
              <p className="font-bolder font-color-3" style={{ marginBottom: '10px' }}>
                {selectedEmployeesWithMfaDisabled.length === 1 ? (
                  <FormattedMessage id="ENGAGE.ENABLE_MFA_PHRASE" />
                ) : (
                  <FormattedMessage id="ENGAGE.ENABLE_MFA_PHRASE_2" />
                )}
              </p>
              <ul>
                {selectedEmployeesWithMfaDisabled.map((employee, i) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <li key={i} className="font-bolder">
                    <span>{`${employee?.firstName ?? ''} ${employee?.lastName ?? ''}`}</span>
                  </li>
                ))}
              </ul>
              <div>
                <p className="font-bolder font-color-3" style={{ marginTop: '40px' }}>
                  <FormattedMessage id="ENGAGE.ENABLE_MFA_NON_BROWSER" />
                </p>
                <p
                  style={{
                    textAlign: 'left',
                    display: 'inline-block',
                    marginLeft: '20px',
                  }}
                >
                  <FormattedMessage id="ENGAGE.ENABLE_MFA_NON_BROWSER_2" />
                  <br />
                  <a href="https://aka.ms/MFASetup" target="_blank" rel="noopener noreferrer">
                    https://aka.ms/MFASetup
                  </a>
                </p>
                <Form.Check
                  custom
                  type="checkbox"
                  id="enableMfaNonBrowserCheck"
                  style={{ marginLeft: '20px' }}
                  checked={nonBrowserSignIn}
                  onChange={handleNonBrowserSignIn}
                  label={
                    selectedEmployeesWithMfaDisabled.length === 1
                      ? disabledEnableMfaCheckboxLabel('ENGAGE.ENABLE_MFA_SEND_LINK')
                      : disabledEnableMfaCheckboxLabel('ENGAGE.ENABLE_MFA_SEND_LINK_2')
                  }
                />
              </div>
            </div>
          </Col>
        </Row>
      </Modal.Body>

      {/* Footer Child */}
      {cloneChildComponents({ ...rest }, children)}
    </Form>
  )
}

export default EnableMfa
